import moment from 'moment';
import React from 'react';


import { Line } from 'react-chartjs-2';
import roundOff from '../../Util/roundOff';

const Graph = ({subscriptionGrowthData = {}, subscribersFilter}) => {

  const getSubsGrowth = () => {
    const values = Object.values(subscriptionGrowthData);
    if(values.length > 0) {
      return values.reduce((acc, red) => {
        acc = acc + red;
        return acc;
      }, 0);
    }
    return 0;
  }
  
  const getLabels = (labels) => {
    return labels.map(label =>{ 
      if(subscribersFilter === 'Last 24 Hours') {
        return moment.utc(label, 'DD-MM-YYYY HH:mm').local().format('DD MMM HH:mm');
      } else {
        return moment.utc(label, 'DD-MM-YYYY HH:mm').local().format('DD MMM');
      };
    });
  }
  
  const data = {
    labels: getLabels(Object.keys(subscriptionGrowthData)),
    datasets: [
      {
        label: 'Subscribers',
        data: Object.values(subscriptionGrowthData),
        fill: true,
        borderColor:'#2C97DE',
        backgroundColor:'#E5F5FF',
      }
    ]
  }

  const options = {
    plugins: {
      legend: {
        align: 'end',
        onClick: (event) => {},
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          // forces step size to be 50 units
          stepSize: 50,
          padding: 5,
        },
        grid: {borderDash: [8, 4], borderDashOffset: 1},
      },
      x: {
        grid: {borderDash: [8, 4], borderDashOffset: 1},
      },
    },
    responsive: true,
    maintainAspectRatio: true,
    redraw: true,
  }
    
  return (<>
      <h2 className="text-dark">{roundOff(getSubsGrowth())}</h2>
      <div className="graph-container" style={{
            maxWidth: '100%',
              width: '100%',
              maxHeight: '300px',
      }}>
          <Line
            data={data}
            options={options}
          />
      </div>
    </>
   )
}

export default Graph;